import {BlockType} from "../../model/markdown/MarkdownText"
import {ParsedBlock} from "./blockParseService"

const orderedListChars: Array<string> = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
const unorderedListChars: Array<string> = ['-', '*', '+']

class ListParserService {
    isOrderedList(curChar: string, line: string, offset: number): boolean {
        if (!orderedListChars.includes(curChar)) {
            return false
        }
        offset++
        while (offset < line.length && orderedListChars.includes(line[offset])) {
            offset++
        }
        if (offset >= line.length || line[offset] !== '.') {
            return false
        }
        offset++
        return offset < line.length && line[offset] === ' '
    }

    isUnorderedList(curChar: string, line: string, offset: number): boolean {
        if (!unorderedListChars.includes(curChar)) {
            return false
        }
        offset++
        while (offset < line.length && unorderedListChars.includes(line[offset])) {
            offset++
        }
        return offset < line.length && line[offset] === ' '
    }

    getOrderedList(line: string, offset: number, lines: Array<string>, lineNo: number, indent: number): ParsedBlock {
        let startFrom = 1
        const startOffset = offset
        while (orderedListChars.includes(line[offset])) {
            offset++
        }
        try {
            startFrom = parseInt(line.substring(startOffset - 1, offset))
        } catch (e) {
            // do nothing
        }
        offset += 2
        const contents: Array<string> = [line.substring(offset)]
        const offsets: Array<number> = [offset]
        const lineIndents: Array<number> = [indent]
        lineNo++
        while (lineNo < lines.length) {
            let lineOffset = 0
            let lineIndent = 0
            const checkLine = lines[lineNo]
            while (lineOffset < checkLine.length) {
                if (checkLine[lineOffset] > ' ') {
                    break
                }
                lineOffset++
                lineIndent++
            }
            const curChar = checkLine[lineOffset]
            if (!this.isOrderedList(curChar, checkLine, lineOffset)) {
                break
            }
            while (orderedListChars.includes(checkLine[lineOffset])) {
                lineOffset++
            }
            lineOffset += 2
            offsets.push(lineOffset)
            contents.push(checkLine.substring(lineOffset))
            lineIndents.push(lineIndent)
            lineNo++
        }
        const subBlocks: Array<ParsedBlock> = []
        for (let i = 0; i < offsets.length; i++) {
            subBlocks.push({
                type: BlockType.ORDERED_LIST,
                offset: offsets[i],
                content: contents[i],
                subBlocks: [],
                lineSkipped: 0,
                startFrom: 1,
                hint: '',
                indent: lineIndents[i],
            })
        }
        return {
            type: BlockType.ORDERED_LIST,
            offset: offset,
            content: line.substring(offset),
            lineSkipped: offsets.length - 1,
            subBlocks,
            startFrom,
            hint: '',
            indent: indent,
        }
    }

    getUnorderedList(line: string, offset: number, lines: Array<string>, lineNo: number, indent: number): ParsedBlock {
        while (unorderedListChars.includes(line[offset])) {
            offset++
        }
        offset++
        const contents: Array<string> = [line.substring(offset)]
        const offsets: Array<number> = [offset]
        const lineIndents: Array<number> = [indent]
        lineNo++
        while (lineNo < lines.length) {
            let lineOffset = 0
            let lineIndent = 0
            const checkLine = lines[lineNo]
            while (lineOffset < checkLine.length) {
                if (checkLine[lineOffset] > ' ') {
                    break
                }
                lineOffset++
                lineIndent++
            }
            const curChar = checkLine[lineOffset]
            if (!this.isUnorderedList(curChar, checkLine, lineOffset)) {
                break
            }
            while (unorderedListChars.includes(checkLine[lineOffset])) {
                lineOffset++
            }
            lineOffset++
            offsets.push(lineOffset)
            contents.push(checkLine.substring(lineOffset))
            lineIndents.push(lineIndent)
            lineNo++
        }
        const subBlocks: Array<ParsedBlock> = []
        for (let i = 0; i < offsets.length; i++) {
            subBlocks.push({
                type: BlockType.UNORDERED_LIST,
                offset: offsets[i],
                content: contents[i],
                subBlocks: [],
                lineSkipped: 0,
                startFrom: 1,
                hint: '',
                indent: lineIndents[i],
            })
        }
        return {
            type: BlockType.UNORDERED_LIST,
            offset: offset,
            content: line.substring(offset),
            lineSkipped: offsets.length - 1,
            subBlocks,
            startFrom: 1,
            hint: '',
            indent: indent,
        }
    }
}

export const listParserService = new ListParserService()
